var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.168,
    height: 60,
    viewBox: "0 0 53.168 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e1e6f0;}.b{fill:#f3f5f9;}.c{fill:#74798c;}.d{fill:#2eb77d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.436 17.933)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H3.516V7.032H0Z",
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 3.045)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.883 35.515)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H3.516V7.032H0Z",
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 3.045)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.439 35.505)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H7.032V3.516H0Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 3.516)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.881 17.925)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H7.032V3.516H0Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 3.516)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.826 8.789)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241,75h3.516v7.148H241Z",
    transform: "translate(-241 -75)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.826 44.063)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241,376h3.516v7.148H241Z",
    transform: "translate(-241 -376)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.438 42.54)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M107.847,374.959l-15.221-8.906,1.758-3.045,15.221,8.906Z",
    transform: "translate(-92.626 -363.007)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.831 42.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M276.857,378.225l-1.682-3.086,15.48-8.542,1.682,3.086Z",
    transform: "translate(-275.175 -366.596)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.92 21.211)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M421,181h3.516v17.585H421Z",
    transform: "translate(-421 -181)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.75 5.509)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M289.707,58.958l-15.221-8.906,1.758-3.045,15.221,8.906Z",
    transform: "translate(-274.486 -47.007)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.438 5.509)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M94.384,58.958l-1.758-3.045,15.221-8.906,1.758,3.045Z",
    transform: "translate(-92.626 -47.007)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.732 21.211)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61,181h3.516v17.585H61Z",
    transform: "translate(-61 -181)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12.422)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M31.787,115.846a5.274,5.274,0,0,1,5.272-9.136h0a5.275,5.275,0,0,1-5.275,9.136Z",
    transform: "translate(-29.152 -106.005)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.624 24.607)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M395.511,325.818a5.274,5.274,0,1,1,7.2-1.933A5.28,5.28,0,0,1,395.511,325.818Z",
    transform: "translate(-392.874 -315.974)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 24.608)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M29.855,323.9a5.273,5.273,0,1,1,7.206,1.931A5.283,5.283,0,0,1,29.855,323.9Z",
    transform: "translate(-29.151 -315.983)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.624)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M393.579,113.907a5.28,5.28,0,0,1,1.928-7.2h0a5.274,5.274,0,1,1-1.931,7.2Z",
    transform: "translate(-392.874 -105.998)"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.31)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M216.273,10.547a5.273,5.273,0,1,1,5.273-5.273A5.279,5.279,0,0,1,216.273,10.547Z",
    transform: "translate(-211)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.31 49.453)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M216.273,432.547a5.273,5.273,0,1,1,5.273-5.273A5.279,5.279,0,0,1,216.273,432.547Z",
    transform: "translate(-211 -422)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.764 14.18)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M152.641,136.82a15.862,15.862,0,0,1-8.789,14.168l-7.031-3.621-7.031,3.621a15.819,15.819,0,1,1,22.852-14.168Z",
    transform: "translate(-121 -121)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.31 21.211)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M216.273,191.547a5.273,5.273,0,1,1,5.273-5.273A5.279,5.279,0,0,1,216.273,191.547Z",
    transform: "translate(-211 -181)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M203.031,286A7.052,7.052,0,0,0,196,293.031v3.621a15.785,15.785,0,0,0,14.063,0v-3.621A7.052,7.052,0,0,0,203.031,286Z",
    transform: "translate(-176.447 -252.484)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErp);
export default __webpack_public_path__ + "static/media/ERP.b082fd2024c6151a76dd8acda0ff03dc.svg";
export { ForwardRef as ReactComponent };